import React, {useEffect, useState} from 'react'
import {inject, observer} from 'mobx-react'
import {withRouter} from 'react-router'
import {Link} from 'react-router-dom'
import Header from './header'
import sunny from '@assets/img/sunny.png'
import cloudy from '@assets/img/cloudy.png'
import heavyRain from '@assets/img/heavyRain.png'
import lightRain from '@assets/img/lightRain.png'
import moderateRain from '@assets/img/moderateRain.png'
import overcast from '@assets/img/overcast.png'
import thunderstorm from '@assets/img/thunderstorm.png'
import indexBtn from '@assets/img/indexBtn.gif'
import lightBtn from '@assets/img/lightBtn.gif'
import clientBtn from '@assets/img/clientBtn.gif'
import energyBtn from '@assets/img/energyBtn.gif'
import realtimeBtn from '@assets/img/realtimeBtn.gif'
import AIBtn from '@assets/img/AIBtn.gif'
import timelineBtn from '@assets/img/timelineBtn.gif'
import {Chart, registerShape} from '@antv/g2';
import {message} from 'antd'
import './index.less'

let runningTime = null
let timer

const CockpitOverflow = inject('store')(
  observer(({
    store,
  }) => {
    const {userInfo} = store
    const [curWeather, setCurWeather] = useState(null)
    const [weatherimg, setWeatherimg] = useState(null)

    //查询现在所在位置城市
    function showCityInfo() {
      //加载城市查询插件 
      AMap.service(["AMap.CitySearch"], function() { 
        //实例化城市查询类 
        let citysearch = new AMap.CitySearch(); 
        //自动获取用户IP，返回当前城市 
        citysearch.getLocalCity(function(status, result){ 
          if(status === 'complete' && result.info === 'OK'){ 
            if(result && result.city && result.bounds) {
              getWeather(result.city)
            } 
          }else{
          } 
        }); 
      });
    }

    //查询当前位置城市天气信息
    function getWeather(curCity) {
      AMap.plugin('AMap.Weather', function() {
        //创建天气查询实例
        let weather = new AMap.Weather();
    
        //执行实时天气信息查询
        weather.getLive(curCity, function(err, data) {
          setCurWeather(data)
          switch (data.weather) {
            case '小雨': setWeatherimg(lightRain);break;
            case '晴': setWeatherimg(sunny);break;
            case '多云': setWeatherimg(cloudy);break;
            case '大雨': setWeatherimg(heavyRain);break;
            case '中雨': setWeatherimg(moderateRain);break;
            case '阴': setWeatherimg(overcast);break;
            case '雷雨': setWeatherimg(thunderstorm);break;
          }
        });
      });
    }
        
    function creatChat(data, runningTime) {
      const chart = new Chart({
        container: 'runningTime',
        autoFit: true,
        height: 180,
        width: 180,
      });
      chart.data(data);
      chart.coordinate('theta', {
        radius: 0.75,
        innerRadius: 0.7,
      });
      // 辅助文本
      chart
        .annotation()
        .text({
          position: ['50%', '50%'],
          content: runningTime,
          style: {
            fontSize: 24,
            fill: '#fff',
            textAlign: 'center',
          },
          offsetY: -10,
        })
        .text({
          position: ['50%', '50%'],
          content: '天',
          style: {
            fontSize: 12,
            fill: '#fff',
            textAlign: 'center',
          },
          offsetY: -6,
          offsetX: 24,
        })
        .text({
          position: ['50%', '50%'],
          content: '项目运行时间',
          style: {
            fontSize: 12,
            fill: '#fff',
            textAlign: 'center',
          },
          offsetY: 14,
        })
      chart
        .interval()
        .adjust('stack')
        .position('percent')
        .color('item', ['#58fded', '#011b43'])
      chart.legend(false)
      chart.tooltip(false)
  
      chart.interaction('element-active');
  
      chart.render();
    }
    
    function creatweather(data) {
      // 自定义Shape 部分
      registerShape('point', 'pointer', {
        draw(cfg, container) {
          const group = container.addGroup({});
          // 获取极坐标系下画布中心点
          const center = this.parsePoint({x: 0, y: 0});
          // 绘制指针
          group.addShape('line', {
            attrs: {
              x1: center.x,
              y1: center.y,
              x2: cfg.x,
              y2: cfg.y,
              stroke: cfg.color,
              lineWidth: 5,
              lineCap: 'round',
            },
          });
          group.addShape('circle', {
            attrs: {
              x: center.x,
              y: center.y,
              r: 9.75,
              stroke: cfg.color,
              lineWidth: 4.5,
              fill: '#fff',
            },
          });

          return group;
        },
      });

      const chart = new Chart({
        container: 'weather-container',
        height: 120,
        width: 120,
        padding: [0, 0, 30, 0],
      });
      chart.data(data);

      chart.coordinate('polar', {
        startAngle: (-8.3 / 8) * Math.PI,
        endAngle: (0.3 / 8) * Math.PI,
        radius: 0.75,
      });
      chart.scale('value', {
        min: 0,
        max: 9,
        ticks: [2.25, 3.75, 5.25, 6.75],
      });

      chart.axis('1', false);
      chart.axis('value', {
        line: null,
        label: {
          offset: 10,
          formatter: (val) => {
            if (val === '2.25') {
              return '优';
            } else if (val === '3.75') {
              return '良';
            } else if (val === '5.25') {
              return '中';
            }

            return '差';
          },
          style: {
            fontSize: 18,
            textAlign: 'center',
          },
        },
        tickLine: null,
        grid: null,
      });
      chart.legend(false);
      chart
        .point()
        .position('value*1')
        .shape('pointer')
        .color('#1890FF');

      // 绘制仪表盘刻度线
      chart.annotation().line({
        start: [3, 0.905],
        end: [3.0035, 0.85],
        style: {
          stroke: '#19AFFA', // 线的颜色
          lineDash: null, // 虚线的设置
          lineWidth: 3,
        },
      });
      chart.annotation().line({
        start: [4.5, 0.905],
        end: [4.5, 0.85],
        style: {
          stroke: '#19AFFA', // 线的颜色
          lineDash: null, // 虚线的设置
          lineWidth: 3,
        },
      });

      chart.annotation().line({
        start: [6, 0.905],
        end: [6.0035, 0.85],
        style: {
          stroke: '#19AFFA', // 线的颜色
          lineDash: null, // 虚线的设置
          lineWidth: 3,
        },
      });

      // 绘制仪表盘背景
      chart.annotation().arc({
        top: false,
        start: [0, 1],
        end: [9, 1],
        style: {
          stroke: '#CBCBCB',
          lineWidth: 15,
          lineDash: null,
        },
      });

      // 绘制指标
      chart.annotation().arc({
        start: [0, 1],
        end: [data[0].value, 1],
        style: {
          stroke: '#1890FF',
          lineWidth: 20,
          lineDash: null,
        },
      });
      // 绘制指标数字
      chart.annotation().text({
        position: ['50%', '90%'],
        content: `${(data[0].value * 50).toFixed(1)}`,
        style: {
          fontSize: 20,
          fill: '#03CBF9',
          textAlign: 'center',
        },
        offsetY: 14,
      });
      chart.render();
    }
    
    function initMap() {
      const map = am5.Root.new("ck-map");
      
      map.setThemes([
        am5themes_Animated.new(map)
      ]);
      
      let chart = map.container.children.push(am5map.MapChart.new(map, {
        panX: "rotateX",
        // rotateX rotateY none
        panY: "none",
        projection: am5map.geoOrthographic(),
        homeGeoPoint: {latitude: 2, longitude: 2},
      }));
      
      
      // Create series for background fill 四大洋
      // https://www.amcharts.com/docs/v5/charts/map-chart/map-polygon-series/#Background_polygon
      let backgroundSeries = chart.series.push(am5map.MapPolygonSeries.new(map, {}));
      backgroundSeries.mapPolygons.template.setAll({
        // fill: map.interfaceColors.get("alternativeBackground"),
        fill: am5.color(0x000e91),
        stroke: am5.color(0x000e91),
        fillOpacity: 0.3,
        strokeOpacity: 0.5
      });
  
      // Add background polygon
      // https://www.amcharts.com/docs/v5/charts/map-chart/map-polygon-series/#Background_polygon
      backgroundSeries.data.push({
        geometry: am5map.getGeoRectangle(90, 180, -90, -180)
      });
      
      // Create graticule series 创建网格
      // https://www.amcharts.com/docs/v5/charts/map-chart/graticule-series/
      let graticuleSeries = chart.series.push(am5map.GraticuleSeries.new(map, {step: 20}));
      graticuleSeries.mapLines.template.setAll({
        strokeOpacity: 0.15, 
        // stroke: map.interfaceColors.get("alternativeBackground"),
        stroke: am5.color(0x3394ef),
      })
  
      // Create main polygon series for countries 七大洲
      // https://www.amcharts.com/docs/v5/charts/map-chart/map-polygon-series/
      let polygonSeries = chart.series.push(am5map.MapPolygonSeries.new(map, {
        geoJSON: am5geodata_worldLow,
        fill: am5.color(0x3394ef),
        stroke: am5.color(0x3394ef)
      }));
      
      polygonSeries.mapPolygons.template.setAll({
        tooltipText: "{name}",
        toggleKey: "active",
        interactive: true
      });
  
      polygonSeries.mapPolygons.template.states.create("hover", {
        fill: map.interfaceColors.get("primaryButtonHover")
      });
  
      // Create line series for trajectory lines 轨迹线
      // https://www.amcharts.com/docs/v5/charts/map-chart/map-line-series/
      let lineSeries = chart.series.push(am5map.MapLineSeries.new(map, {}));
      lineSeries.mapLines.template.setAll({
        stroke: am5.color(0xffffff),
        strokeOpacity: 1
      });
      
      // Create point series for markers
      // https://www.amcharts.com/docs/v5/charts/map-chart/map-point-series/
      let pointSeries = chart.series.push(am5map.MapPointSeries.new(map, {}));
      
      pointSeries.bullets.push(function() {
        let circle = am5.Circle.new(map, {
          radius: 7,
          // tooltipText: "Drag me!",
          cursorOverStyle: "pointer",
          tooltipY: 0,
          fill: am5.color(0xffba00),
          stroke: map.interfaceColors.get("background"),
          strokeWidth: 2,
          draggable: true
        });
      
        circle.events.on("dragged", function(event) {
          let dataItem = event.target.dataItem;
          let projection = chart.get("projection");
          let geoPoint = chart.invert({x: circle.x(), y: circle.y()});
      
          dataItem.setAll({
            longitude: geoPoint.longitude,
            latitude: geoPoint.latitude
          });
        });
      
        return am5.Bullet.new(map, {
          sprite: circle
        });
      });

      let hangzhou = addCity({latitude: 30.4643, longitude: 120.2454}, "Hang Zhou");
      let beijing = addCity({latitude: 39.801149, longitude: 116.497178}, "Bei Jing");
      let guangzhou = addCity({latitude: 23.161654, longitude: 113.258781}, "Guang Zhou");
      let Dubai = addCity({latitude: 25.294803, longitude: 55.294486}, "Dubai");
      let SaudiArabia = addCity({latitude: 24.715601, longitude: 46.649716}, "Saudi Arabia");
      let Afghanistan = addCity({latitude: 34.367629, longitude: 64.00851}, "Afghanistan");
      let Kazakhstan = addCity({latitude: 48.5129, longitude: 72.158512}, "Kazakhstan");
      let Singapore = addCity({latitude: 1.363764, longitude: 103.86223}, "Singapore");
      let Moscow = addCity({latitude: 55.787703, longitude: 37.530776}, "Moscow");
      let London = addCity({latitude: 51.553297, longitude: -0.146888}, "London");
      let USA1 = addCity({latitude: 40.878174, longitude: -73.88035}, "New York");
      let USA2 = addCity({latitude: 34.097234, longitude: -118.294617}, "Los Angeles");
      let USA3 = addCity({latitude: 49.277782, longitude: -123.179099}, "Vancouver");
      let USA4 = addCity({latitude: 56.135342, longitude: -106.343322}, "Canada");
      let USA5 = addCity({latitude: 65.273552, longitude: -152.962072}, "Alaska State");
      let Mexico = addCity({latitude: 19.462399, longitude: -99.131581}, "Mexico");
      let Brazil = addCity({latitude: -15.755495, longitude: -47.876712}, "Brazil");
      let Peru = addCity({latitude: -10.400997, longitude: -75.399068}, "Peru");
      let Argentina = addCity({latitude: -39.634926, longitude: -67.525025}, "Argentina");
      let Egypt = addCity({latitude: 26.765797, longitude: 29.887819}, "Egypt");
      let Congo = addCity({latitude: 0.283775, longitude: 21.885837}, "Congo");
      let SouthAfrica = addCity({latitude: -30.614423, longitude: 24.755816}, "South Africa");
      let Australia1 = addCity({latitude: -16.414681, longitude: 130.328148}, "Victoria");
      let Australia2 = addCity({latitude: -27.126211, longitude: 123.199195}, "Australia3");
      let Australia3 = addCity({latitude: -27.471373, longitude: 143.463818}, "Australia2");
      
      let lineDataItem = lineSeries.pushDataItem({
        pointsToConnect: [beijing, hangzhou, guangzhou, Singapore, Australia1, Australia2, Australia3, USA5, USA4, USA3, USA2, USA1, Mexico, Peru, Argentina, Brazil,
          SouthAfrica, Congo, Egypt, London, Moscow, Kazakhstan, Afghanistan, SaudiArabia, Dubai, beijing]
      });
      
      let planeSeries = chart.series.push(am5map.MapPointSeries.new(map, {}));
      
      let plane = am5.Graphics.new(map, {
        svgPath:
          "m2,106h28l24,30h72l-44,-133h35l80,132h98c21,0 21,34 0,34l-98,0 -80,134h-35l43,-133h-71l-24,30h-28l15,-47", //飞机图标创建
        scale: 0.1,
        centerY: am5.p50,
        centerX: am5.p50,
        fill: am5.color(0xd6d9da)
      });
      
      
      planeSeries.bullets.push(function() {
        let container = am5.Container.new(map, {});
        container.children.push(plane);
        return am5.Bullet.new(map, {sprite: container});
      });
      
      // 创建飞机图标
      let planeDataItem = planeSeries.pushDataItem({
        lineDataItem: lineDataItem,
        positionOnLine: 0,
        autoRotate: true
      });
      
      // 飞机图标移动
      planeDataItem.animate({
        key: "positionOnLine",
        to: 1,
        duration: 60000,
        loops: Infinity,
        easing: am5.ease.yoyo(am5.ease.linear)
      });
      
      planeDataItem.on("positionOnLine", function(value) {
        if (value >= 0.99) {
          plane.set("rotation", 180);
        } else if (value <= 0.01) {
          plane.set("rotation", 0);
        }
      });
      
      function addCity(coords, title) {
        return pointSeries.pushDataItem({
          latitude: coords.latitude,
          longitude: coords.longitude
        });
      }
      
      // Rotate animation 旋转动画
      chart.animate({
        key: "rotationX",
        from: 0,
        to: 360,
        duration: 16000,
        loops: Infinity,
      });
  
      // Make stuff animate on load
      chart.appear(1000, 100);
      timer = 1
      $('#ck-map').on('click', function () {
        clearTimeout(timer)
        timer = setTimeout(() => {
          chart.animate({
            key: "rotationX",
            from: 0,
            to: 360,
            duration: 16000,
            loops: Infinity,
          });
        }, 5000)
      });
    }

    useEffect(() => {
      showCityInfo()
      if(!!userInfo && !document.getElementById('runningTime').getElementsByTagName('canvas').length) {
        runningTime = Math.floor((new Date() - new Date(userInfo.gmtCreate))/24/60/60/1000)
        creatChat([{
          item: '运行时间', percent: 0.75},{
          item: '未满时间', percent: 0.25
        }], runningTime)
        $.ajax({
          type : "get",
          dataType: 'json',
          url : "/weather/highchart/1416",     //请求的url。与后端@Request Mapping注解中的值一致。
          success : function(data) {
            creatweather([{value: data.city.pm25iaqi/50}])
          },
          error : function(e) {        //请求失败的回调函数
          }
        });
      }
    }, [userInfo])

    useEffect(() => {
      if(!timer) {
        initMap()
      } else {
        timer = null
      }
    }, [weatherimg])

    return (
      <div className="ck-overview">
        <Header/>
        <div className="ck-project">
          <div className='ck-top'>
            <div className='ck-map' id='ck-map'></div>
          </div>
          <div className='ck-btn'>
            <div className='ck-item'>
              <Link className="ck-index btn-1"
                to="/cockpit/timeline"
              >
                <div className="ck-content">
                  <img src={timelineBtn}/>
                  <div>智慧演绎</div>
                </div>
              </Link>
              <Link className="ck-index btn-2"
                to="/cockpit/lightControl"
              >
                <div className="ck-content">
                  <img src={lightBtn}/>
                  <div>智慧灯光</div>
                </div>
              </Link>
              <Link className="ck-index btn-3"
                to="/cockpit/energyStatistics"
              >
                <div className="ck-content">
                  <img src={energyBtn}/>
                  <div>智慧强电</div>
                </div>
              </Link>
              <Link className="ck-index btn-4"
                to="/cockpit/index"
              >
                <div className="ck-content">
                  <img src={indexBtn}/>
                  <div>智慧驾驶舱</div>
                </div>
              </Link>
              <Link className="ck-index btn-5"
                to="/cockpit/realtimeMonitor"
              >
                <div className="ck-content">
                  <img src={realtimeBtn}/>
                  <div>智慧安防</div>
                </div>
              </Link>
              <Link className="ck-index btn-6"
                to="/cockpit/clientManagement"
              >
                <div className="ck-content">
                  <img src={clientBtn}/>
                  <div>智慧管控</div>
                </div>
              </Link>
            </div>
            <div className='weather-text'>
              <div className='weather-txt'>
                <div>天气质量</div>
                <div className='weather-t'>优</div>
              </div>
              <div className='weather-container' id='weather-container'></div>
            </div>
            <div className='runningTime' id='runningTime'></div>
            <div className='weather'>
              <div className='weather-city'>{curWeather ? curWeather.city : null}</div>
              <div>
                <span className='weather-temperature'>{curWeather ? curWeather.temperature+'℃' : null}</span>
                <div className='weather-weather'><img className='weather-img' src={weatherimg ? weatherimg : null}/>{curWeather ? curWeather.weather : null}</div>
              </div>
              <div className='weather-wind'>
                <div className='weather-bg'>风向</div>
                <div className='weather-bg weather-right weather-num'>{curWeather ? curWeather.windDirection+"风" : null}</div>
                <div className='weather-bg'>湿度</div>
                <div className='weather-bg weather-num'>{curWeather ? curWeather.humidity : null}</div>
              </div>
              <div className='weather-humidity'>
                <div className='weather-bg'>风力</div>
                <div className='weather-bg weather-right weather-num'>{curWeather ? curWeather.windPower+'级' : null}</div>
                <div className='weather-bg'>压强</div>
                <div className='weather-bg weather-num'>1023hpa</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  })
)

export default withRouter(CockpitOverflow)